import { useEffect } from "react";
import { useRouterState } from "@tanstack/react-router";

const AGENT_ID = "agent_2401kqtzrq59fdtakphq07w8wtzc";
const SCRIPT_SRC = "https://unpkg.com/@elevenlabs/convai-widget-embed";
const ELEMENT_ID = "heallexa-elevenlabs-convai";

export function ElevenLabsWidget() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const isDashboard = pathname.startsWith("/dashboard");

  useEffect(() => {
    if (isDashboard) {
      const existing = document.getElementById(ELEMENT_ID);
      if (existing) existing.remove();
      return;
    }
    if (!document.getElementById(ELEMENT_ID)) {
      const el = document.createElement("elevenlabs-convai");
      el.id = ELEMENT_ID;
      el.setAttribute("agent-id", AGENT_ID);
      document.body.appendChild(el);
    }
    if (!document.querySelector(`script[data-elevenlabs-convai]`)) {
      const s = document.createElement("script");
      s.src = SCRIPT_SRC;
      s.async = true;
      s.type = "text/javascript";
      s.setAttribute("data-elevenlabs-convai", "true");
      document.body.appendChild(s);
    }
  }, [isDashboard]);

  return null;
}
